import {createContext, useContext, useState} from "react";
import type {ReactNode} from "react";

const LayoutContext = createContext<any>(undefined);

interface Props {
  children: ReactNode;
}

function LayoutProvider({children}: Props) {
  const [showLoader, setShowLoader] = useState(false);
  const [showWaitingModal, setShowWaitingModal] = useState(false);
  // Optional text shown inside the waiting modal (e.g. bulk-operation progress).
  const [waitingModalText, setWaitingModalText] = useState(null);

  const values = {
    showLoader,
    setShowLoader,
    showWaitingModal,
    setShowWaitingModal,
    waitingModalText,
    setWaitingModalText
  };

  return <LayoutContext.Provider value={values}>{children}</LayoutContext.Provider>;
}

function useLayout() {
  return useContext(LayoutContext);
}

export {LayoutProvider, useLayout};
